<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	import {
		input_status_check,
		input_settings_check,
		is1LWithMultipleInputs,
	} from '../../../helpers/interface_helpers';
	import { bulkUpdate } from './app_settings_helper';
	//Stores
	import { getDeviceStatus, readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices } from 'src/stores/lists/devices';
	import { real_id } from '../../../helpers/interface_helpers';
	//Design system components
	import { Alert, Toggle } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../types/Device';
	import type { InputClickEvent } from 'src/types/InputClickEvent';

	export let device: Device;

	const id = device.id;
	const settings = readDeviceSettings(id);
	const btnTypeNotMomentary = settings && input_settings_check(settings, device);

	let checked = $devices[id].input_state || false;
	let waitForResponse = false;

	$: statusStore = getDeviceStatus(id);
	$: status = $statusStore;
	// TODO  This value doesn't updates. Used in Alert, I think we should use checked.
	// $: inputStatus =
	// 	status && btnTypeNotMomentary && input_status_check(status, device);

	const save = async (e: InputClickEvent) => {
		waitForResponse = true;
		checked = e.target.checked;
		const input_state = checked;
		const res = await bulkUpdate(id, { input_state });

		if (!res?.isok) {
			// Revert to prev value when request fails
			checked = !checked;
		}

		onSettingsResponse(res, device);
		waitForResponse = false;
	};
</script>

<Toggle size="m" {checked} disabled={waitForResponse} class="mb-s" on:click={save} id="toggle-6pq4c86">
	{is1LWithMultipleInputs(device?.type)
		? $format('input_state_identifier_new', {
				default: 'Add input state identifiers to the device status labels.',
			})
		: $format('input_state_identifier', {
				default: 'Add input state identifier to the power button.',
			})}
</Toggle>

{#if status}
	{#if btnTypeNotMomentary || is1LWithMultipleInputs(device?.type)}
		<Alert
			type={checked ? 'success' : 'danger'}
			heading={checked
				? $format('input_is_turn_on', { default: 'Input is turn on' })
				: $format('input_is_turn_off', { default: 'Input is turn off' })}
		/>
	{:else}
		<Alert
			heading={$format('input_state_hidden_warning', {
				default:
					'"Input state" identifier is hidden because the channel button type is set to "Momentary".',
			})}
			type={'warning'}
		/>
	{/if}
{/if}
